import api from '@/api'

export default {
  getAllArbitrations(page, limit, sort = 'created_at', sortOrder = 'desc', status = []) {
    const statusRequest = status.length ? `&status[]=${status.join('&status[]=')}` : ''
    return api.get(`/arbitrations?page=${page}&limit=${limit}&sort_by=${sort}&order=${sortOrder}${statusRequest}`)
  },

  getAllArbitrationsAndWealthDecision(page, limit, sort = 'created_at', sortOrder = 'desc', status = []) {
    const statusRequest = status.length ? `&status[]=${status.join('&status[]=')}` : ''
    return api.get(`/arbitrations/mixed_index?page=${page}&limit=${limit}&sort_by=${sort}&order=${sortOrder}${statusRequest}`)
  },

  getArbitration(arbitrationId) {
    return api.get(`/arbitrations/${arbitrationId}`)
  },

  getUrlsStatistics() {
    return api.get(`/links/statistics`)
  },

  getUrlSupport() {
    return api.get(`/links/support`)
  },

  getAdvisors() {
    return api.get('cabp_users/available_advisors')
  },

  generateArbitrationPdf(arbitrationId) {
    return api.post(`arbitrations/${arbitrationId}/generate_pdf`)
  }
}
